/**
 * Extras max quantity filter, used for filtering out filters when the max quantity has been reached.
 */
bookingApp.filter('extrasMaxQuantity',['$filter',function(){
    var extrasFilter = function(input, cart){
        var out = [];
        angular.forEach(input, function(extra){
            if(typeof extra.maxPerBooking !== 'undefined' && extra.maxPerBooking){
                var extrasCount = 0;
                // loop through the extras in the cart and check if the max has been hit
                angular.forEach(cart.rooms, function(room){
                    angular.forEach(room.selectedExtras, function(roomExtra){
                        if(roomExtra.extra.id === extra.id){
                            extrasCount += roomExtra.quantity;
                        }
                    });
                });
                // loop through the booking level extras
                angular.forEach(cart.bookingExtras.selected, function(bookingExtra){
                    if(bookingExtra.extra.id === extra.id){
                        extrasCount += bookingExtra.quantity;
                    }
                });
                if(extrasCount < extra.maxPerBooking){
                    out.push(extra);
                }
            } else {
                out.push(extra);
            }
        });
        return out;
    };
    return extrasFilter;
}]);
